import React, { useState, useEffect }  from 'react'
import { Route, useLocation, useHistory   } from 'react-router-dom'
import qs from 'query-string';
import { Home as Home25 } from '../pages/2025'
import Work from '../pages/2025/Work'
import Grads from '../pages/2025/Grads'
import Events from '../pages/2025/Events'
import About from '../pages/2025/About'
import Letterbox from '../pages/2025/Letterbox'
import Search from '../pages/2025/Search'
import Teaser from '../pages/2025/Teaser'
import Profile from '../pages/2025/Profile'
import Project from '../pages/2025/Project'
import Awards from '../pages/2025/Awards'
import Committee from '../pages/2025/Committee'

const ProfileRouteWrapper = ({ getScrollTop }) => {
  const location = useLocation();
  const history = useHistory(); // Get history object for navigation
  const { id } = qs.parse(location.search);
  const [showRedirectMessage, setShowRedirectMessage] = useState(false); // State for message

  useEffect(() => {
    let timeoutId = null;

    if (!id && !showRedirectMessage) { // Only run if no ID and message isn't already shown
      console.log("ProfileRouteWrapper: No ID found. Setting timer for redirect.");
      // No ID found, show message and set timer to redirect
      setShowRedirectMessage(true);
      timeoutId = setTimeout(() => {
        console.log("ProfileRouteWrapper: Redirecting to /grads");
        history.push('/grads'); // Redirect to grads page
      }, 1000);
    }

    // Cleanup function: Clear the timeout if the component unmounts
    // or if the 'id' appears before the timeout finishes.
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
        console.log("ProfileRouteWrapper: Cleared redirect timer.");
      }
    };
  }, [id, history, showRedirectMessage]); // Dependencies for the effect

  // If showRedirectMessage is true, display the message
  if (showRedirectMessage) {
    return <div>No profile ID specified. Navigating back...</div>;
  }

  // If there IS an ID, render the Profile component with the key
  if (id) {
    // Pass the extracted 'id' as the 'key' prop to Profile
    // This tells React to treat profiles with different IDs as distinct component instances
    return <Profile key={id} getScrollTop={getScrollTop} />;
  }

  // Optional: Render null or a minimal loader while initially checking for ID
  // This handles the very brief period before the effect runs
  return null;
};



export const getRoutes2025 = (getScrollTop) => [
  // <Route
  //   key={'Index25'}
  //   exact
  //   path='/'
  //   render={(props) => <Home25 {...props} getScrollTop={getScrollTop} />}
  // />,
  <Route
    key={'Home25'}
    exact
    path='/home'
    render={(props) => <Home25 {...props} getScrollTop={getScrollTop} />}
  />,
  <Route
    key={'Work25'}
    exact
    path='/work'
    render={(props) => <Work {...props} getScrollTop={getScrollTop} />}
  />,
  <Route
    key={'Grads25'}
    exact
    path='/grads'
    render={(props) => <Grads {...props} getScrollTop={getScrollTop} />}
  />,
  <Route
    key={'Events25'}
    exact
    path='/events'
    render={(props) => <Events {...props} getScrollTop={getScrollTop} />}
  />,
  <Route
    key={'About25'}
    exact
    path='/about'
    render={(props) => <About {...props} getScrollTop={getScrollTop} />}
  />,
  <Route
    key={'Letterbox'}
    exact
    path='/letterbox'
    render={(props) => <Letterbox {...props} getScrollTop={getScrollTop} />}
  />,
  <Route
    key={'Search'}
    exact
    path='/search'
    render={(props) => <Search {...props} getScrollTop={getScrollTop} />}
  />,
  <Route
    key={'Teaser25'}
    exact
    path='/teaser'
    render={(props) => <Teaser {...props} getScrollTop={getScrollTop} />}
  />,
  <Route
    key='student'
    exact
    path='/student'
    render={(props) => <Profile {...props} getScrollTop={getScrollTop} />}
  />,
  <Route
    key='project'
    exact
    path='/project'
    render={(props) => <Project {...props} getScrollTop={getScrollTop} />}
  />,
  <Route
    key='awards'
    exact
    path='/awards'
    render={(props) => <Awards {...props} getScrollTop={getScrollTop} />}
  />,
  <Route
    key='committee'
    exact
    path='/committee'
    render={(props) => <Committee {...props} getScrollTop={getScrollTop} />}
  />,
]
